import React, {useState} from "react";
import styled from "styled-components";
import PageHeader from "../../components/organisms/PageHeader";
import spriteImage from '../../assets/images/sprite.png';
import {device} from "../../assets/styles/media";

const FaqListArea = styled.ul`
    margin-bottom: 140px;
    li:last-child {
        border-bottom: 1px solid #eaeaea;
    }
    ${device.mobile}{
      font-weight: 500;
        margin-top: 30px;
        margin-bottom: 50px;
    }
`;

const FaqItem = styled.li`
    border-top: 1px solid #eaeaea;
    cursor: pointer;
   
`;

const QueBox = styled.div`
    display: flex;
    line-height: 24px;
    position: relative;
    align-items: center;\
    padding: 23px 30px;
    
`;
const AskBox = styled.div`
    background-color: #f9f9f9;
    position: relative;
    padding: 23px 30px;
    border-top: 1px solid #eaeaea;
    display: none;
    &.open {
        display: block;
    }
`;


const Icon = styled.span`
    position: absolute;
    left: 30px;
    top: 16px;
    width: 40px;
    height: 40px;
    background-image: url(${spriteImage});
    background-size: 418px 402px;
    background-repeat: no-repeat;
    background-position: -378px 0;

    ${device.tablet} {
        zoom: 0.8;
        left: 20px;
        top: 25%;
    }

    ${device.mobile} {
        zoom: 0.7;
        left: 20px;
        top: 30%;
    }
`;

const Icon2 = styled(Icon)`
    background-position: -378px -42px;

    ${device.tablet} {
        top: 10%;
    }
`;
const Arrow = styled.span`
    position: absolute;
    width: 12px;
    height: 12px;
    border-top: 1px solid #777;
    border-right: 1px solid #777;
    display: inline-block;
    right: 30px;
    top: ${({isOpen}) => (isOpen ? "34px" : "24px")};
    transform: ${({isOpen}) => (isOpen ? "rotate(-45deg)" : "rotate(135deg)")};
    transition: transform 0.3s ease;
    
    
    ${device.mobile} {
        top: 60px;
        zoom: 0.5;
    }
`;


const QuestionText = styled.span`
    font-size: 16px;
    margin-left: 60px;
    display: inline-block;
    line-height: 24px;
    letter-spacing: -0.3px;
    text-align: left;
    color: #222;

    ${device.tablet} {
        margin-left: 35px;
        width: 85%;
    }
    ${device.mobile} {
        font-size: 13px;
        margin-left: 30px;
        line-height: 20px;
        letter-spacing: -0.5px;
        width: 85%;
    }
`;

const AnswerText = styled(QuestionText)`
    color: #777;
`;

const Faq = () => {
    const [openList, setOpenList] = useState([0]);
    const navList = [
        {
            name: "공지",
            link: "/notice/announcement"
        },
        {
            name: "캠페인",
            link: "/notice/campaign"
        },
        {
            name: "강아지숲 이야기",
            link: "/notice/dstory"
        },
        {
            name: "자주하는 질문",
            link: "/notice/faq"
        },
    ];
    const faqList = [
        {
            question: '강아지숲은 어떤 공간인가요?',
            answer: ' 강아지숲은 강아지가 말하는 숲이라는 상상에서 출발해요.\n' +
                '강아지의 마음을 듣고 강아지와 사람이 더 나은 세상을 만들어 갈 수 있게 도움을 주는, 국내를 대표하는 반려견 테마파크이자 반려인과 반려견 그리고 비반려인 모두가 즐길 수 있는 복합문화공간이기도 해요.\n' +
                '지금 강아지와 함께 하지 않더라도, 올바른 반려 문화에 대한 전시 및 프로그램을 즐기면서 사람과 강아지의 행복한 동행을 원하는 이들을 위한 곳이에요.'
        },
        {
            question: '강아지들의 입장 제한 구역이 있나요?',
            answer: '강아지숲 강아지를 위해 조성된 공간인 만큼, 강아지는 강아지숲 어디든 입장할 수 있어요. 다만, 박물관동에 강아지를 동반할 경우, 다른 방문객들을 배려하고 쾌적한 관람 환경 유지를 위하여 \n' +
                '강아지에게 산책줄과 매너벨트를 반드시 착용시켜 주세요.(매표소서 1두당 매너벨트 1개를 ' +
                '무료 제공하여 매너벨트 추가 필요시, 강아지숲 마켓에서 구입하실 수 있습니다.)'
        },
        {
            question: '유모차를 가지고 가도 괜찮나요?',
            answer: '강아지숲은 \'있는 그대로의 자연을 최대한 훼손하지 않는 범위\'에서 만들어진 공간이에요.\n' +
                '그러다 보니 경사와 계단으로 이루어진 산책로의 경우는 유모차나 휠체어의 이동이 어려워요. \n' +
                '모두의 안전과 자연을 생각해 마련된 공간이오니 여러분의 너른 양해 부탁드려요.'
        },
        {
            question: '강아지와 함께 식음료 시설을 이용할 수 있나요?',
            answer: '네이처풀 내부에 위치한 네이처 푸드테라스에서는 강아지를 동반하여 식사가 가능하고, 강아지숲 내 모든 카페에서는 강아지와 함께 맛있는 음료와 간식거리를 즐길 수 있어요.'

        },
        {
            question: '오프-리시 공간은 어디인가요?',
            answer: '강아지숲 전 구역은 산책줄 착용이 원칙이지만, 예외적으로 동산과 운동장(큰운동장, 작은운동장, 네이처풀 운동장)에서는 강아지들이 스트레스를 풀며 놀 수 있도록 오프-리시 구역으로 운영하고 있어요. \n' +
                '다만, 사고 방지를 위해 중소형견과 대형견(체중 10kg 기준)의 동산/운동장 오프-리시 스케줄이 정해져 있으니 사전에 홈페이지 또는 인스타그램에서 일정 확인을 부탁드려요.'
        },
        {
            question: '산책로에서 오프-리시를 해도 되나요?',
            answer: '강아지숲 내 운동장 및 동산을 제외한 전 구역에서는 꼭 산책줄을 해야 해요. 특히 산책로는 넓은 부지 특성상 어디서 다른 강아지들을 마주칠지 예측하기가 어려워요. 산책줄을 하지 않으면, \n'
                + '이는 강아지의 돌발 행동으로 이어져 자칫 큰 사고를 발생시킬 수 있기 때문에 안전을 위해 산책줄을 꼭 해주셔야 해요.'
        },
        {
            question: '중소형견과 대형견이 오프-리시 공간을 함께 이용할 수 있나요?',
            answer: '안전상의 이유로 오프-리시 공간에서는 함께 이용이 불가해요. 다만, 오프-리시 공간을 제외한 모든 공간에서는 산책줄을 착용한 상태에서 함께 이용할 수 있어요.'
        },
        {
            question: '내부 셔틀버스를 운영하나요?',
            answer: '방문객들의 편의를 위해 무료 셔틀버스 서비스를 제공하고 있어요. 강아지와 함께 탑승할 수 있으며, 입장권 구매 고객에 한해 무료 이용이 가능해요. \n'
                + '※ (박물관 앞 주차장 내 승강장)박물관 출발 > 큰/작은운동장 도착 > 네이처풀 도착 \n' +
                ' 10:30 / 11:00 / 11:30 / 12:00 / 13:00 / 13:30 / 14:00 / 14:30 / 15:00 / 15:30 / 16:00 / 16:30 / 17:00 \n' +
                '※ (네이처풀 승강장)네이처풀 출발 > 박물관 도착 \n' +
                ' 11:10 / 11:40 / 12:10 / 12:40 / 13:40 / 14:10 / 14:40 / 15:10 / 15:40 / 16:10 / 16:40 / 17:10 / 17:40 \n' +
                '*셔틀버스 운행 구간의 개인차량 이동은 안전 상의 이유로 불가합니다.'
        },
        {
            question: '강아지숲 입장이 제한되는 강아지가 있나요?',
            answer: '강아지숲은 모두의 공간이지만 안전 관리를 위해 입장이 제한되는 강아지를 안내드리고 있어요.\n' +
                '다음에 해당하는 강아지들은 입마개를 하더라도 다른 강아지와 방문객들을 위해 아쉽지만 강아지숲 방문이 어려워요.\n' +
                '해당되는 맹견이 아니더라도, 강아지숲 트레이너의 판단하에 이용 제한이 있을 수 있음을 양해하여 주세요.\n' +
                '*동물보호법 시행규칙 제1조 2항에 근거한 맹견 품종(도사견, 아메리칸 핏불 테리어, 아메리칸 스태퍼드셔 테리어, 스태퍼드셔 불 테리어, 로트와일러 및 그 잡종의 개)\n' +
                '*동물보호법상 맹견으로 표기되지 않았으나 위압감을 주거나 공격 성향이 강한 품종(도고 아르헨티노, 케인코르소, 오브차카, 티베탄 마스티프, 울프독 등 및 그 잡종의 개)\n' +
                '*기타 다른 반려견 또는 사람에게 피해를 줄 수 있는 개\n' +
                '소중한 반려견들의 안전을 위한 조치라는 점, 양해 부탁드려요.'
        },
        {
            question: '강아지숲에 입장하는 강아지들은 어떤 예방접종이 되어 있어야 하나요?',
            answer: ' 강아지숲은 소중한 강아지들이 건강하고 즐겁게 뛰어놀다 갈 수 있도록 노력하고 있어요. 종합백신, 켄넬코프,코로나 장염, 광견병 접종을 5차까지 완료하고 항체가 검사 결과의 수치가 충분한 강아지라면 \n' +
                ' 강아지숲 입장이 가능해요.'
        },
        {
            question: '강아지숲에서 참여할 수 있는 프로그램이 있나요?',
            answer: " 강아지숲은 시즌마다 다채로운 이벤트 및 캠페인/프로그램을 운영하고 있어요. 방문 전 홈페이지 알림란(또는 특별프로그램란)과 인스타그램을 확인하시는 것을 추천드려요.\n" +
                "상시 프로그램으로는 보호자와 강아지가 산책로를 걸으며 다양한 포토존들에서 함께 인증샷을 찍고 미션을 완성하는 '산책로 포토존 챌린지'가 마련되어 있어요."
        },
        {
            question: '분실물은 어디에 문의하나요?(전화 또는 현장 문의가 가능합니다.)',
            answer: '                      강아지숲 대표번호 033-913-1400으로 전화 주시거나 박물관 1층 인포메이션 또는 매표소로 문의하시면 분실물을 찾으실 수 있도록 도와드리고 있어요.\n'
        },
        {
            question: '강아지 외 반려동물의 입장이 가능한가요?',
            answer: '                      강아지숲은 강아지와 사람을 위한 공간으로, 안전사고 방지를 위해 강아지 외 동물은 입장이 불가해요.\n'
        },
        {
            question: '외부 음식을 가지고 들어갈 수 있나요?',
            answer: '   음식물로 인해 발생될 수 있는 안전사고 방지를 위해 외부 음식의 반입을 제한하고 있어요. 양해를 부탁드려요.'
        }, {
            question: '카페 내부에서 강아지의 산책줄을 풀어놔도 되나요?',
            answer: ' 강아지들간의 접촉으로 인한 사고를 예방하기 위해 운동장/동산을 제외한 모든 구간에서는 산책줄 착용을 부탁드려요.\n'
        },
        {
            question: '오프-리시 공간에서 강아지 장난감 이용이 가능한가요?',
            answer: ' 강아지와 즐거운 시간을 보낼 수 있도록 동산 또는 운동장에서 원반 및 공 등 강아지용 장난감이 허용돼요. 다만, 장난감으로 인해 강아지들 간 다툼이 발생할 수 있으니 놀이 시간 동안 보호자분들의 각별한\n' +
                '주의를 부탁드려요.배드민턴채 등 사람을 위한 놀이 및 운동기구는 안전 상의 이유로 반입이 어려우니 양해 부탁드려요.\n'

        },
        {
            question: '폭우나 폭설 등 날씨와 상관없이 이용이 가능한가요?',
            answer:
                '기상 악화로 안전 상 이용이 어려울 것으로 예상되는 경우, 일기예보를 고려하여 오전 11시 경 당일 이용가능 시간을 홈페이지 및 인스타그램 상에 공지하고 있으니 참고 부탁드려요.'

        },


    ];

    const addOpenList = (index) => {
        //해당 item 내부 askBox display block
        setOpenList((prev) =>
            prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
        );
    };

    return (
        <>
            <PageHeader
                bTitle="알림"
                detail="자주하는 질문"
                desc="강아지숲의 자주하는 질문입니다."
                list={navList}
                top={true}
            />
            <FaqListArea>
                {faqList.map((item, index) => (
                    <FaqItem key={index} onClick={() => addOpenList(index)}>
                        <QueBox>
                            <Icon/><QuestionText>{item.question}</QuestionText><Arrow
                            isOpen={openList.includes(index)}/>
                        </QueBox>
                        <AskBox className={openList.includes(index) ? "open" : ""}>
                            <Icon2/><AnswerText
                            dangerouslySetInnerHTML={{__html: item.answer.replace(/\n/g, "<br />")}}/></AskBox>
                    </FaqItem>

                ))}
            </FaqListArea>
        </>
    );
};

export default Faq;
